export default {"src":"/_next/static/media/loading.6a0a3fe9.gif","height":800,"width":800};